'use strict';

// 初期化関数の定義
var initSectionProductColumn = {
  init: function init() {
    /*
    *
    *  Swiper
    *
    */
    var swiper = void 0;
    var options = {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    };
    var initSwiper = function initSwiper() {
      if (ONIBUS.data.$MQ === 'PORTRAIT') {
        swiper = new Swiper('.js-product-column_sectionImage', options);
        swiper.on('slideChange', setCurrent);
        initPagenation();
      }
      window.addEventListener('resize', switchSwiper);
    };
    // デバイスで条件分岐
    var switchSwiper = function switchSwiper() {
      if (ONIBUS.data.$MQ === 'PORTRAIT') {
        if (swiper) return;
        swiper = new Swiper('.js-product-column_sectionImage', options);
        swiper.on('slideChange', setCurrent);
        initPagenation();
      } else {
        if (!swiper) return;
        swiper.destroy();
        swiper = undefined;
      }
    };
    // ページネーション初期化
    var initPagenation = function initPagenation() {
      $('.js-product-column_pagenationCurrent').text(swiper.realIndex + 1);
      $('.js-product-column_pagenationTotal').text($('.js-product-column_sectionImage_node').length);
    };
    // カレント書き換え
    var setCurrent = function setCurrent() {
      $('.js-product-column_pagenationCurrent').text(swiper.realIndex + 1);
    };
    // Swiper初期化
    initSwiper();
  }

  // グローバルスコープに sectionProductColumn が存在するかチェックし、存在すれば初期化しない
};if (!window.sectionProductColumn) {
  window.sectionProductColumn = initSectionProductColumn; // window オブジェクトに追加
  sectionProductColumn.init(); // 初期化実行
}